<a *ngIf="pwaEnabled" routerLink="/{{CommonRoutes.REQUEST_PASSWORD}}">Recupero password</a><br />
<a *ngIf="!pwaEnabled" class="navigation-link" href="https://check-cantiere.it/resetting/request">Recupero password</a><br />
